import * as React from "react";
import { Path, G, ClipPath, Defs, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const LRIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="LR" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="M0 0h16v12H0V0Z"
        clipRule="evenodd"
      />
      <Path fill="#E31D1C" d="M.014 2.75h16v1.5h-16z" />
      <Path
        fill="#E31D1C"
        fillRule="evenodd"
        d="M0 0h16v1.5H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#E31D1C"
        d="M-.029 5.5h16V7h-16zM.056 8.2h16v1.5h-16zM.051 10.75h16v1.5h-16z"
      />
      <Path
        fill="#3D58DB"
        fillRule="evenodd"
        d="M0 0h8v7H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="M4.066 4.607 2.606 5.62l.466-1.736L2 2.776l1.452-.06L4.066 1l.615 1.716H6.13L5.06 3.884l.536 1.633-1.53-.91Z"
        clipRule="evenodd"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
